export const capitalizarPrimeraLetra = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
export const obtenerNombreDia = (fecha) => {
  let dia = "";
  switch (fecha) {
    case "lunes":
      dia = "Lunes";
      break;
    case "martes":
      dia = "Martes";
      break;
    case "miércoles":
      dia = "Miércoles";
      break;
    case "jueves":
      dia = "Jueves";
      break;
    case "viernes":
      dia = "Viernes";
      break;
    case "sábado":
      dia = "Sábado";
      break;
    case "domingo":
      dia = "Domingo";
      break;
  }
  return dia;
};

function parseSpecial(rtf) {
  // Encontrar todas las secuencias \'xx
  let matches = rtf.match(/\\'[a-f0-9]{2}/g);
  // Eliminar duplicados en el arreglo
  let special = [...new Set(matches)];
  // Recorrer para remplazar
  special.forEach((hex) => {
    // Convertir de hexadecimal a decimal, eliminando primero la marca \'
    let dec = parseInt(hex.replace("\\'", ""), 16);
    // Remplazar secuencia por caracter correspondiente
    rtf = rtf.replaceAll(hex, String.fromCharCode(dec));
  });
  return rtf;
}
export function convertToPlain(rtf) {
  if (rtf) {
    // Interpretar contenido original
    rtf = rtf.replace(/\\par[d]?/g, "");
    rtf = rtf.replace(/\{\*?\\[^{}]+}|[{}]|\\\n?[A-Za-z]+\n?(?:-?\d+)?[ ]?/g, "").trim();
    // Buscar secuencias de caracteres especiales y devolver
    return parseSpecial(rtf);
  } else {
    return "-";
  }
}
